var _path, _polygon, _rect, _rect2, _rect3, _rect4, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebpage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 7.811,
    y: 67.86,
    style: {
      fill: "#FFFFFF"
    },
    width: 496.38,
    height: 376.292
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#027EA8"
    },
    points: "183.945,260.003 183.945,147.917 408.116,147.917 408.116,260.003 183.945,260.003 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84DCCF"
    },
    d: "M448.305,285.218c-7.598,1.433-13.541,7.376-14.974,14.974l-1.778,9.422 c-3.247,5.411-11.09,5.411-14.337,0l-39.663-66.105c-2.42-4.035-1.785-9.199,1.542-12.526l0,0c3.327-3.327,8.492-3.963,12.526-1.542 l66.105,39.663c5.411,3.247,5.411,11.09,0,14.337L448.305,285.218z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.811,
    y: 67.86,
    style: {
      fill: "#E6E6E6"
    },
    width: 80.061,
    height: 376.292
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.841,
    y: 147.915,
    style: {
      fill: "#FBB03B"
    },
    width: 96.072,
    height: 256.193
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.811,
    y: 67.86,
    style: {
      fill: "#027EA8"
    },
    width: 496.38,
    height: 40.031
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#84DCCF"
    },
    cx: 95.875,
    cy: 227.981,
    r: 48.031
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.092,
    y: 100.301,
    style: {
      fill: "#F15A24"
    },
    width: 15.622,
    height: 15.622
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.334,
    y: 100.301,
    style: {
      fill: "#FBB03B"
    },
    width: 16.663,
    height: 15.622
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.614,
    y: 100.301,
    style: {
      fill: "#F15A24"
    },
    width: 16.663,
    height: 15.622
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,60.046v391.908h512V60.046H0z M15.622,436.332V75.668h480.757v24.638H127.903v15.622h368.476v320.406H15.622V436.332z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "368.085,267.814 176.134,267.814 176.134,140.106 415.927,140.106 415.927,219.972 400.305,219.972  400.305,155.728 191.755,155.728 191.755,252.192 368.085,252.192 "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 175.805,
    y: 291.925,
    style: {
      fill: "#F15A24"
    },
    width: 184.334,
    height: 15.622
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 175.805,
    y: 324.209,
    width: 23.953,
    height: 15.622
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 175.805,
    y: 348.162,
    width: 80.191,
    height: 15.622
  })), /*#__PURE__*/React.createElement("rect", {
    x: 271.617,
    y: 348.162,
    style: {
      fill: "#FBB03B"
    },
    width: 40.616,
    height: 15.622
  }), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 327.854,
    y: 348.162,
    width: 80.191,
    height: 15.622
  })), /*#__PURE__*/React.createElement("rect", {
    x: 175.805,
    y: 372.115,
    style: {
      fill: "#84DCCF"
    },
    width: 119.765,
    height: 15.622
  }), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 175.805,
    y: 396.068,
    width: 176.003,
    height: 15.622
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.031,140.106v271.817h111.695V140.106H40.031z M136.104,396.303H55.652V266.659 c10.168,10.57,24.437,17.167,40.226,17.167s30.058-6.596,40.225-17.167V396.303z M55.652,227.979 c0-22.181,18.045-40.225,40.226-40.225c22.181,0,40.225,18.045,40.225,40.225s-18.045,40.225-40.225,40.225 C73.697,268.204,55.652,250.159,55.652,227.979z M95.878,172.132c-15.789,0-30.059,6.597-40.226,17.167v-33.57h80.452v33.57 C125.937,178.728,111.668,172.132,95.878,172.132z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M424.385,321.483c-5.733,0-10.916-2.935-13.866-7.85l-39.664-66.105c-4.272-7.121-3.154-16.195,2.716-22.067 c5.875-5.874,14.948-6.989,22.069-2.717l66.104,39.663c4.917,2.949,7.851,8.134,7.851,13.867c0,5.732-2.935,10.916-7.85,13.867 l-1.198,0.719l-10.796,2.037c-4.47,0.844-7.902,4.276-8.746,8.746l-2.037,10.794l-0.719,1.198 C435.301,318.548,430.117,321.483,424.385,321.483z M386.346,235.788c-0.632,0-1.256,0.245-1.728,0.717 c-0.794,0.794-0.945,2.021-0.367,2.985l39.663,66.104c0.055,0.092,0.144,0.241,0.399,0.263l1.342-7.115 c2.044-10.835,10.365-19.157,21.202-21.201l7.114-1.342c-0.023-0.256-0.172-0.345-0.265-0.4l-66.104-39.663 C387.212,235.904,386.778,235.788,386.346,235.788z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 71.665,
    y: 363.784,
    style: {
      fill: "#FFFFFF"
    },
    width: 47.906,
    height: 15.622
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.665,
    y: 300.256,
    style: {
      fill: "#FFFFFF"
    },
    width: 47.906,
    height: 15.622
  })), /*#__PURE__*/React.createElement("rect", {
    x: 71.665,
    y: 332.541,
    style: {
      fill: "#F15A24"
    },
    width: 47.906,
    height: 15.622
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebpage);
export default __webpack_public_path__ + "static/media/webpage.32c7fa6d3e9e50c666b4c953ff4257de.svg";
export { ForwardRef as ReactComponent };